/* eslint-disable no-undef */
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.thumbnails = this.querySelector('[data-thumbnails]') || false;
    this.productType = this.getAttribute('data-product-type');
    this.denominations = document.querySelector('[data-size-list]');
    this.mainGallery = this.querySelector('[data-main-gallery]');

    window.addEventListener('load', () => {

      this.thumbSlider = new Swiper((this.thumbnails), {
        slidesPerView: 5,
        spaceBetween: 10,
        freeMode: true,
        allowTouchMove: false,
        watchSlidesProgress: true,
      });


      if(this.productType == 'gift_card' || this.productType == 'multi_variant'){

        this.denomSlider =  new Swiper((this.denominations), {
          slidesPerView: 5,
          spaceBetween: 10,
          freeMode: true,
          allowTouchMove: false,
          watchSlidesProgress: true,
          noSwiping: true,
        });


        this.main = new Swiper(this.querySelector('[data-main-gallery]'), {
          spaceBetween: 10,
          noSwiping: false,
          navigation: {
            nextEl: '[data-next]',
            prevEl: '[data-prev]',
          },
          thumbs: {
            swiper: this.denomSlider,
          },
          breakpoints: {
            // when window width is >= 768px
            768: {
              noSwiping: true,
              noSwipingClass: 'swiper-slide'
            }
          }
        });
      }
      else {


        this.main = new Swiper(this.querySelector('[data-main-gallery]'), {
          spaceBetween: 10,
          noSwiping: false,
          navigation: {
            nextEl: '[data-next]',
            prevEl: '[data-prev]',
          },
          thumbs: {
            swiper: this.thumbSlider,
          },
          breakpoints: {
            // when window width is >= 768px
            768: {
              noSwiping: true,
              noSwipingClass: 'swiper-slide'
            }
          }
        });
      }
      this.thumbnails.classList.remove('opacity-0');
    });
  }
}
customElements.define('product-gallery', ProductGallery);
